<template>
    <div class="card mt-3">
        <div class="card-header bg-primary text-white">
            <div class="card-title h5 m-0">
                {{ isEnVersion ? panel.labelEn : panel.label }}
            </div>
        </div>
        <div class="card-body row">
            <component v-for="(component, index) in panel.components"
                :key="index"
                :is="component.fieldType"
                :type="component.type"
                :model="component"
                :details="details"
                :allowAnonymous="allowAnonymous"
                :requiredIdentification="false"
                :validateUniqueIdNumber="false"
                :validateEgn="true"
                :isNew="isNew"
                :profile-data="profileData"
                :is-evaluation-panel="panel.isEvaluationPanel"
                @deleteSavedFile="deleteSavedFile">
            </component>
        </div>
    </div>
</template>

<script>
    import Input from '../dynamic/Input';
    import Toggle from '../dynamic/Toggle';
    import Datepicker from '../dynamic/Datepicker';
    import Dropdown from '../dynamic/Dropdown';
    import FileUpload from './FileUpload';
    import Person from './Person';
    import Address from './Address';
    import StarRating from './StarRating';
    import { DynamicRegisterFieldValueModel } from '@/models/models';
    import { mapGetters } from 'vuex';

    export default {
        inject: ['$validator'],
        props: {
            panel: Object, // EditorPanel, // TODO:
            value: [], // TODO:
            isNew: {
                type: Boolean,
                default: false
            },
            details: {
                type: Boolean,
                default: false
            },
            allowAnonymous: {
                type: Boolean,
                default: true
            },
            profileData: {
                type: Object,
                default() {
                    return null;
                }
            }
        },
        data() {
            return {
                fieldValue: new DynamicRegisterFieldValueModel()
            }
        },
        components: {
            Input,
            Toggle,
            Datepicker,
            Dropdown,
            FileUpload,
            Person,
            Address,
            StarRating
        },
        computed: {
            ...mapGetters(['isEnVersion']),
        },
        methods: {
            deleteSavedFile(fileId) {
                this.$emit('deleteSavedFile', fileId);
            }
        },
        mounted () {
            this.panel.uid = this._uid;
        }
    }
</script>
